import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { actions } from '../../../Data/ReduxViewModels/SearchWorksheets';
import { worksheetNavLinks } from '../../../Data/Search';
import { Button, TextInput } from '../../Core';
import SearchNav from '../SearchNav';
import './AdvancedSearch.scss';

const searchWorksheetsLimit = 50;

const AdvancedSearch = () => {
  const dispatch = useDispatch();
  const searchWorksheets = useSelector((state) => state.searchWorksheets.advancedWorksheets);
  const searchingForWorksheets = useSelector((state) => state.searchWorksheets.advancedSearching);
  const filter = useSelector((state) => state.searchWorksheets.filter);
  const appSearchText = useSelector((state) => state.searchWorksheets.advancedSearch);
  const [searchText, setSearchText] = useState(useSelector((state) => state.searchWorksheets.advancedSearch ?? ''));

  const getSearchResults = useCallback(() => {
    dispatch(
      actions.advancedSearchGet({
        limit: searchWorksheetsLimit,
        searchId: uuidv4(),
      })
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      actions.advancedSearchSetSearch({
        search: searchText?.trim(),
      })
    );
  }, [dispatch, searchText]);

  useEffect(() => {
    setSearchText(appSearchText ?? '');
  }, [dispatch, appSearchText]);

  useEffect(() => {
    getSearchResults();
  }, [getSearchResults, filter]);

  const handleKeyDown = (e) => {
    const ENTER_KEYCODE = 13;
    if (e.keyCode === ENTER_KEYCODE && !e.defaultPrevented) {
      getSearchResults();
    }
  };

  return (
    <div className="AdvancedSearch">
      <div className="AdvancedSearch-Search">
        <div className="AdvancedSearch-Search-Text">
          <TextInput
            placeholder="Search for Sample ID"
            maxLength="20"
            autoFocus
            onChange={(e) => setSearchText(e.data.value)}
            value={searchText}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="AdvancedSearch-Search-Button">
          <Button primary loading={searchingForWorksheets} onClick={() => getSearchResults()}>
            Search
          </Button>
        </div>
      </div>
      <div className={classNames('AdvancedSearch-Items', { 'AdvancedSearch-Items-disabled': searchingForWorksheets })}>
        <SearchNav
          links={worksheetNavLinks(searchWorksheets?.worksheets, searchWorksheets?.search, true)}
          heading={undefined}
          placeholder={
            !!searchWorksheets
              ? 'No matching search results were found.'
              : 'Click search or press enter to begin searching.'
          }
        />
      </div>
    </div>
  );
};

export { AdvancedSearch };
export default AdvancedSearch;
